import { Body, Button, FlexBox, Message } from '@Backlot-Cars/archie';
import { useTranslation } from 'next-i18next';

const PaymentMethodsUnavailable = ({ onBack, onRetry }) => {
	const { t } = useTranslation(['signup']);

	return (
		<FlexBox flexDirection="column" gap="lg">
			<Message borderColor="alert" color="alert" iconColor="alert" iconName="exclamation">
				<FlexBox flexDirection="column" gap="xs">
					<Body bold>{t('signup:auctionAccessLookup.paymentMethodsStep.unavailableTitle')}</Body>
					<Body>{t('signup:auctionAccessLookup.paymentMethodsStep.unavailableSubTitle')}</Body>
				</FlexBox>
			</Message>
			<FlexBox flexDirection="row-reverse" gap="sm" justifyContent="space-between">
				{onRetry && (
					<Button onClick={onRetry}>{t('signup:auctionAccessLookup.paymentMethodsStep.retry')}</Button>
				)}
				<Button variant="tertiary" onClick={onBack}>
					{t('signup:actions.back')}
				</Button>
			</FlexBox>
		</FlexBox>
	);
};

export default PaymentMethodsUnavailable;
